import polyfills from './js/polyfills'
import formsFunctionality from './js/forms'
import headerAnimations from './js/header'
import slidersInit from './js/sliders-init'
import masonryBlock from './js/masonryBlock'
import cartScripts from './js/cart'
import smallCartFunctionality from './js/small-cart'
import accessoryModal from './js/accessory-modal'
import categoryPage from './js/category-page'
import cartPage from './js/cart-page'
import checkoutScripts, {cardText} from "./js/checkout";
import imageBlock from './js/imageBlock'

polyfills()

jQuery(document).ready(function() {
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
        document.body.classList.add('ios-device')
    }

    headerAnimations(jQuery)
    formsFunctionality(jQuery)
    smallCartFunctionality()
    slidersInit(jQuery)

    if (document.body.classList.contains('single-product')) {
        cartScripts()
        accessoryModal()
        cardText()
    }

    if (document.getElementsByClassName('single-category').length) {
        categoryPage()
    }

    if (document.getElementsByClassName('woocommerce-cart').length) {
        cartPage()
    }

    if (document.getElementsByClassName('woocommerce-checkout').length) {
        checkoutScripts(jQuery)
    }

    const videoPart = document.getElementById('image-block-video')

    if (videoPart) {
        imageBlock(videoPart, jQuery)
    }
})

jQuery(window).on('load', function() {
    masonryBlock()
})
